import { registerValidator } from '../validatorRegistry';

const MAX_HARD = 25 * 1024 * 1024;
const MAX_SOFT = 10 * 1024 * 1024;

registerValidator({
  key: 'file-size',
  runsOn: ['upload'],
  async validate(ctx) {
    const size = ctx.file!.size;
    if (size > MAX_HARD) {
      return {
        key: 'file-size', status: 'error', blocker: true,
        title: 'File too large',
        message: `This file is ${(size / 1024 / 1024).toFixed(1)} MB. Maximum allowed is 25 MB.`,
        suggestion: 'Compress the image or reduce its dimensions before uploading.',
      };
    }
    if (size > MAX_SOFT) {
      return {
        key: 'file-size', status: 'warning', blocker: false,
        title: 'Large file',
        message: `This file is ${(size / 1024 / 1024).toFixed(1)} MB. Large files may slow down the builder.`,
      };
    }
    return { key: 'file-size', status: 'pass', blocker: false, title: 'File size OK', message: `${(size / 1024 / 1024).toFixed(1)} MB` };
  },
});
